import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import { Component, useEffect, useState, Suspense, useRef } from "react";
import { LOG_OUT, USER_DATA } from "./config/endpoint";
import SessionExpiredModal from "./components/common/Dialog/AlertDialog/Seessionexpirelogoutalert";
import PublicRoute from "./components/common/publicroute.js";
import { shouldAutoLogout } from "./utils/cookieUtils";
import { lazy } from "react";
import { Box, CircularProgress } from "@mui/material";
const QuestionDetailLayout = lazy(
  () => import("./components/layouts/QuestionDetailsLayout"),
);

const StudentResultViewAllSolutionLayout = lazy(
  () => import("./components/layouts/StudentresultViewallsolutionsLayout"),
);

const QuestionAddLayout = lazy(
  () => import("./components/layouts/QuestionAddLayout"),
);
const QuestionReviewLayout = lazy(
  () => import("./components/layouts/QuestionReviewLayout"),
);
const Login = lazy(() => import("./components/screens/Login/Login"));
const TeacherLangingPageLayout = lazy(
  () => import("./components/layouts/TeacherLandingPageLayout"),
);
const EditQuestionLayout = lazy(
  () => import("./components/layouts/EditQuestionLayout"),
);
const ForgotPassword = lazy(
  () => import("./components/screens/ForgotPassword/ForgotPassword"),
);
const FolderLayout = lazy(() => import("./components/layouts/FolderLayout"));
const SelectedFolderLayout = lazy(
  () => import("./components/layouts/SelectedFolderLayout"),
);
const AssessmentLayout = lazy(
  () => import("./components/layouts/AssessmentLayout"),
);
const SelectedAssessmentLayout = lazy(
  () => import("./components/layouts/SelectedAssessmentLayout"),
);
const AssessmentDetailsLayout = lazy(
  () => import("./components/layouts/AssessmentDetailsLayout"),
);
const FolderAssessmentLayout = lazy(
  () => import("./components/layouts/FolderAssessmentLayout"),
);
const ReviewAssessmentLayout = lazy(
  () => import("./components/layouts/ReviewAssessmentLayout"),
);
const AssessmentSettingsLayout = lazy(
  () => import("./components/layouts/AssessmentSettingsLayout"),
);
const AssessmentSelectedFolderLayout = lazy(
  () => import("./components/layouts/AssessmentSelectedFolderLayout"),
);
const SeeResultLayout = lazy(
  () => import("./components/layouts/SeeResultLayout"),
);
const AssessmentSeeDetailsLayout = lazy(
  () => import("./components/layouts/AssessmentsSeeDetailsLayout"),
);
const ReviewAssessmentEditDetailsLayout = lazy(
  () => import("./components/layouts/ReviewEditAssessmentLayout"),
);
const CreateQuestionsLayout = lazy(
  () => import("./components/layouts/CreateQuestionsLayout"),
);
const CreateAddQuestionsLayout = lazy(
  () => import("./components/layouts/CreadteAddquestionsLayout"),
);
const CreateEditQuestionsLayout = lazy(
  () => import("./components/layouts/CreateEditQuestionsLayout"),
);
const CreateQuestionsReviewLayout = lazy(
  () => import("./components/layouts/CreateQuestionReviewLayout"),
);
const AllQuestionEditLayout = lazy(
  () => import("./components/layouts/AllQuestionsEditLayout"),
);
const AllQuestionDetailsLayout = lazy(
  () => import("./components/layouts/AllQuestionDetailsLayout"),
);
const AssessmentEditquestionsLayout = lazy(
  () => import("./components/layouts/AssessmenteditquestionLayout"),
);
const EditAssessmentSettingsLayout = lazy(
  () => import("./components/layouts/EditAssessmentSettingsLayout"),
);
const EditSelectFolderAssessmentLayout = lazy(
  () => import("./components/layouts/EditSelectedfolderAssessmentLayout"),
);
const ResultScreenDetailsLayout = lazy(
  () => import("./components/layouts/ResultsScreenDetailsLayout"),
);
const ResultSubmittedLayout = lazy(
  () => import("./components/layouts/ResultSubmittedLayout"),
);
const ResultNotSubmittedLayout = lazy(
  () => import("./components/layouts/ResultNotSubmittedLayout"),
);
const AllAnswersLayout = lazy(
  () => import("./components/layouts/AllAnswersLayout"),
);
const AnswerReviewDescriptiveLayout = lazy(
  () => import("./components/layouts/AnswerReviewDescriptiveLayout"),
);
const DescriptiveGradeLayout = lazy(
  () => import("./components/layouts/DescriptiveGradeLayout"),
);
const SurveyResults = lazy(
  () => import("./components/screens/Results/SurveyResult"),
);
const OmrUploadQuestionsLayout = lazy(
  () => import("./components/layouts/OmrUploadQuestionsLayout"),
);
const OmrAnswerAssignLayout = lazy(
  () => import("./components/layouts/OmrAnswerAssignQnsLayout"),
);
const OmrReviewAssessmentLayout = lazy(
  () => import("./components/layouts/OmrReviewAssessmentLayout"),
);
const OmrAssessmentSettingsLayout = lazy(
  () => import("./components/layouts/OmrAssessmentSettingsLayout"),
);
const OmrEditAssessmentLayout = lazy(
  () => import("./components/layouts/OmrEditAssessmentLayout"),
);
const OmrEditAnswerAssignLayout = lazy(
  () => import("./components/layouts/OmrEditAnswerAssignLayout"),
);
const OmrEditAssessmentsettingsLayout = lazy(
  () => import("./components/layouts/OmrEditAssessmentsettingsLayout"),
);
const EditAssessmentDetail = lazy(
  () =>
    import("./components/screens/Assessments/AssessmentDetails/editassessmentdetails"),
);
const EditInstructionDetail = lazy(
  () =>
    import("./components/screens/Assessments/AssessmentDetails/editInstructiondetails"),
);
const Commonlandingpage = lazy(
  () => import("./components/screens/LandingPage/CommonLandingPage"),
);
const Studentlandingpage = lazy(
  () => import("./components/screens/LandingPage/studentlandingpage"),
);
const TeacherLandingPage = lazy(
  () => import("./components/screens/LandingPage/Teacherlandingpage"),
);
const Organisation = lazy(
  () => import("./components/screens/LandingPage/organisationlandingpage"),
);
const ContactUsForm = lazy(
  () => import("./components/screens/LandingPage/Contactus"),
);
const FAQSupportSection = lazy(
  () => import("./components/screens/LandingPage/helpcenter"),
);
const StudentLandingScreenLayout = lazy(
  () => import("./components/layouts/StudentLandingscreenLayout"),
);
const GetAiPropmpt = lazy(
  () =>
    import("./components/screens/Homepage/Studentlandingscreen").then(
      (module) => ({ default: module.GetAiPropmpt }),
    ),
);
const StudentTeacherConnect = lazy(
  () =>
    import("./components/screens/Homepage/Studentlandingscreen").then(
      (module) => ({ default: module.StudentTeacherConnect }),
    ),
);
const StudentTeacherConnectResource = lazy(
  () =>
    import("./components/screens/Homepage/Studentlandingscreen").then(
      (module) => ({ default: module.StudentTeacherConnectResource }),
    ),
);
const StudentSelfStudy = lazy(
  () =>
    import("./components/screens/Homepage/Studentlandingscreen").then(
      (module) => ({ default: module.StudentSelfStudy }),
    ),
);
const StudentFindAssessment = lazy(
  () =>
    import("./components/screens/Homepage/Studentlandingscreen").then(
      (module) => ({ default: module.StudentFindAssessment }),
    ),
);
const StudentSeeResults = lazy(
  () =>
    import("./components/screens/Homepage/Studentlandingscreen").then(
      (module) => ({ default: module.StudentSeeResults }),
    ),
);
const AssessmentResultsLayout = lazy(
  () => import("./components/layouts/AssessmentResultsLayout"),
);
const AdvancedSearchPageLayout = lazy(
  () => import("./components/layouts/AdvancedSearchPageLayout"),
);
const UserProfileLayout = lazy(
  () => import("./components/layouts/UserprofileLayout"),
);
const UserProfileEmailLayout = lazy(
  () => import("./components/layouts/UserProfileEmailLayout"),
);
const UserProfilePasswordLayout = lazy(
  () => import("./components/layouts/UserProfilePasswordLayout"),
);
const UserProfileDeleteLayout = lazy(
  () => import("./components/layouts/UserProfileDeleteLayout"),
);
const UserProfileEditLayout = lazy(
  () => import("./components/layouts/UserProfileEditLayout"),
);
const GuestLoginPage = lazy(
  () => import("./components/screens/Student/Guest/GuestLogin"),
);
const GuestHomePage = lazy(
  () => import("./components/screens/Student/Guest/GuestHomePage"),
);
const Instruction = lazy(
  () => import("./components/screens/Student/Guest/Instruction"),
);
const AssessmentInstruction = lazy(
  () => import("./components/screens/Student/Guest/AssessmentInstruction"),
);
const LOOQSearchLayout = lazy(
  () => import("./components/layouts/LOOQSearchLayout.js"),
);
const AdvancedSearchLOOQLayout = lazy(
  () => import("./components/layouts/AdvancedSearchLOOQLayout.js.js"),
);
const AddtoAssessmentDetailsLayout = lazy(
  () => import("./components/layouts/AddToAssessmentDetailsLayout.js"),
);
const InstructionReg = lazy(
  () => import("./components/screens/Student/Assessment/InstructionReg"),
);
const QuestionUploadCsvLayout = lazy(
  () => import("./components/layouts/QuestionUploadCSvLayout.js"),
);
const AddtoanotherfolderLayout = lazy(
  () => import("./components/layouts/AddToAnotherFolderLayout.js"),
);
const AssessmentCloneDetailsLayout = lazy(
  () => import("./components/layouts/AssessmentCloneDetailsLayout.js"),
);
const Createaccount = lazy(
  () => import("./components/screens/Registration/Createaccount.js"),
);
const FaqPage = lazy(() => import("./components/screens/LandingPage/FAQ.js"));
const AdvancedSearchScreenLayout = lazy(
  () => import("./components/layouts/AdvancedSearchScreenLayout.js"),
);
const TestUI = lazy(
  () => import("./components/screens/Student/Assessment/TestAttempt.js"),
);
const ReviewAnswers = lazy(
  () => import("./components/screens/Student/Assessment/TestReviewpage.js"),
);
const Congratulations = lazy(
  () => import("./components/screens/Student/Assessment/Congratulations.js"),
);
const ResultCard = lazy(
  () => import("./components/screens/Student/Assessment/ResultCard.js"),
);
const StudyAdvisor = lazy(
  () => import("./components/screens/Student/Assessment/StudyAdvisor.js"),
);
const Viewallsolutions = lazy(
  () => import("./components/screens/Student/Assessment/Viewallsolutions.js"),
);
const StudyAdvisors = lazy(
  () => import("./components/screens/Student/Results/ResultStudyadvisor.js"),
);
const ScheduleRevisionPlan = lazy(
  () => import("./components/screens/Student/Results/ScheduleRevisionPlan.js"),
);
const InstructionPreview = lazy(
  () =>
    import("./components/screens/Assessments/PreviewAssessment/previewInstruction.js"),
);
const PreviewTestUI = lazy(
  () =>
    import("./components/screens/Assessments/PreviewAssessment/Previewtestattempt.js"),
);
const PreviewReviewAnswers = lazy(
  () =>
    import("./components/screens/Assessments/PreviewAssessment/Previewreviewpae.js"),
);
const PreviewCongratulations = lazy(
  () =>
    import("./components/screens/Assessments/PreviewAssessment/PreviewCongrats.js"),
);
const PreviewResultCard = lazy(
  () =>
    import("./components/screens/Assessments/PreviewAssessment/Previewresultcard.js"),
);
const PreviewStudyAdvisor = lazy(
  () =>
    import("./components/screens/Assessments/PreviewAssessment/PreviewStudyadvisor.js"),
);
const PreViewallsolutions = lazy(
  () =>
    import("./components/screens/Assessments/PreviewAssessment/PreviewSolutionSheet.js"),
);
const OmrEditUploadQuestionsLayout = lazy(
  () => import("./components/layouts/Omredituploadquestions.js"),
);
const StudentPerformanceLayout = lazy(
  () => import("./components/layouts/StudentPerformanceLayout.js"),
);
const SurveyAssessmentLayout = lazy(
  () => import("./components/layouts/SurveyAssessmentsLayout.js"),
);
const SurveyAssessmentdetailsLayout = lazy(
  () => import("./components/layouts/SurveyAssessmentdetailsLayout.js"),
);
const EditSurveyAssessmentDetailsLayout = lazy(
  () => import("./components/layouts/EditSurveyAssessmentdetails.js"),
);
const AssessmentSurveySeeDetailsLayout = lazy(
  () => import("./components/layouts/AssessmentSurveySeedetailsLayout.js"),
);
const AddtoSurveyAssessmentDetailsLayout = lazy(
  () => import("./components/layouts/AddToSurveyAssessmntdetailsLayout.js"),
);
const AssessmentClonesurveyDetailsLayout = lazy(
  () => import("./components/layouts/AssessmentCloneSurveyDetailsLayout.js"),
);
const GenAILayout = lazy(
  () => import("./components/layouts/GenAILayout.js"),
);
const ReusableDrawerLayout = lazy(
  () => import("./components/layouts/ReusableDrawerLayout"),
);

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAuthenticated");
  const location = useLocation();

  if (isAuthenticated) {
    return children;
  } else {
    const redirectTarget = `${location.pathname || ""}${location.search || ""}${location.hash || ""}`;
    return <Navigate to={`/?redirect=${encodeURIComponent(redirectTarget)}`} replace />;
  }
};

// Loading component for Suspense fallback
const PageLoader = () => (
  <Box
    sx={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      zIndex: 1300,
    }}
  >
    <CircularProgress sx={{ color: '#1C4E50' }} />
  </Box>
);

const CHUNK_RELOAD_KEY = "qnatestChunkReload";

const isChunkLoadError = (error) => {
  const message = String(error?.message || "");
  const name = String(error?.name || "");

  return (
    name === "ChunkLoadError" ||
    message.includes("ChunkLoadError") ||
    message.includes("Loading chunk")
  );
};

class ChunkErrorBoundary extends Component {
  state = { error: null, alreadyRetried: false };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return;

    const reloadKey = String(error?.message || window.location.pathname);
    const savedReload = JSON.parse(
      sessionStorage.getItem(CHUNK_RELOAD_KEY) || "{}",
    );
    const alreadyRetried =
      savedReload.key === reloadKey && Date.now() - savedReload.time < 10000;

    if (!alreadyRetried) {
      sessionStorage.setItem(
        CHUNK_RELOAD_KEY,
        JSON.stringify({ key: reloadKey, time: Date.now() }),
      );
      window.location.reload();
    } else {
      this.setState({ alreadyRetried: true });
    }
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    if (!isChunkLoadError(this.state.error)) {
      throw this.state.error;
    }

    if (this.state.alreadyRetried) {
      return (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            backgroundColor: '#fff',
            zIndex: 1300,
            textAlign: 'center',
            padding: 3,
          }}
        >
          <Box sx={{ color: '#1C4E50', fontSize: '1.1rem', fontWeight: 600 }}>
            This page failed to load a required update.
          </Box>
          <Box sx={{ color: '#555' }}>
            Please refresh the page. If this keeps happening, contact support.
          </Box>
          <button
            onClick={() => {
              sessionStorage.removeItem(CHUNK_RELOAD_KEY);
              window.location.reload();
            }}
            style={{
              padding: '10px 24px',
              backgroundColor: '#1C4E50',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontSize: '1rem',
            }}
          >
            Retry
          </button>
        </Box>
      );
    }

    return <PageLoader />;
  }
}

// Add this CSS animation to your App.css or as a style tag
const loaderStyle = document.createElement("style");
loaderStyle.textContent = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
document.head.appendChild(loaderStyle);

const normalizeRouterBasename = (value = "") => {
  const trimmedValue = String(value || "").trim();
  if (!trimmedValue || trimmedValue === "/") return "/";

  try {
    const parsedUrl = new URL(trimmedValue, window.location.origin);
    const normalizedPath = String(parsedUrl.pathname || "/").replace(/\/+$/, "");
    return normalizedPath || "/";
  } catch {
    const normalizedPath = trimmedValue.startsWith("/") ? trimmedValue : `/${trimmedValue}`;
    return normalizedPath.replace(/\/+$/, "") || "/";
  }
};

const getRouterBasename = () => {
  const configuredBasename = normalizeRouterBasename(process.env.REACT_APP_BASENAME);
  if (configuredBasename !== "/") return configuredBasename;

  const publicBasename = normalizeRouterBasename(process.env.PUBLIC_URL);
  if (publicBasename !== "/") return publicBasename;

  return "/";
};

function App() {
  const [sessionExpired, setSessionExpired] = useState(
    sessionStorage.getItem("sessionExpiredNotice") === "true",
  );
  const basename = getRouterBasename();
  const toAppPath = (path) =>
    `${basename === "/" ? "" : basename}${path.startsWith("/") ? path : `/${path}`}`;
  const forceLogoutRef = useRef(false);
  const nativeFetchRef = useRef(window.fetch.bind(window));

  const redirectToLogin = () => {
    window.location.replace(toAppPath("/login"));
  };

  const clearLocalAuthState = () => {
    localStorage.clear();
    sessionStorage.clear();
  };

  const forceLogoutNow = async () => {
    sessionStorage.removeItem("sessionExpiredNotice");
    setSessionExpired(false);
    forceLogoutRef.current = false;
    redirectToLogin();
  };

  const logoutCurrentSession = async () => {
    if (forceLogoutRef.current) return; // Prevent multiple calls
    forceLogoutRef.current = true;
    try {
      await nativeFetchRef.current(LOG_OUT, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });
    } catch (_) {}
    clearLocalAuthState();
    redirectToLogin();
  };

  const handleSessionExpired = () => {
    if (forceLogoutRef.current) return;
    clearLocalAuthState();
    sessionStorage.setItem("sessionExpiredNotice", "true");
    setSessionExpired(true);
    redirectToLogin();
  };

  // Detect invalid session from any API call.
  useEffect(() => {
    const originalFetch = window.fetch.bind(window);

    window.fetch = async (...args) => {
      try {
        const response = await originalFetch(...args);
        const clonedResponse = response.clone();

        let data = null;
        try {
          data = await clonedResponse.json();
        } catch {
          data = null;
        }

        if (data?.session_expired === 1) {
          handleSessionExpired();
          return Promise.reject(new Error("Session expired"));
        }

        return response;
      } catch (error) {
        throw error;
      }
    };

    return () => {
      window.fetch = originalFetch;
    };
  }, []);

  // Detect invalid session even when user is idle (no clicks/actions).
 useEffect(() => {
  const checkSessionHeartbeat = async () => {
    const isAuthenticated = localStorage.getItem("isAuthenticated");

    if (!isAuthenticated || forceLogoutRef.current) return;

    try {
      const response = await nativeFetchRef.current(USER_DATA, {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
      });

      let data = null;
      try {
        data = await response.clone().json();
      } catch {}

      if (data?.session_expired === 1) {
        handleSessionExpired();
      }
    } catch (_) {
      // ignore
    }
  };

  // ✅ Run once on mount
  checkSessionHeartbeat();

  // ✅ Run when user comes back to tab
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      checkSessionHeartbeat();
    }
  };

  document.addEventListener("visibilitychange", handleVisibilityChange);

  return () => {
    document.removeEventListener("visibilitychange", handleVisibilityChange);
  };
}, []);

  // Auto-logout when cookies are empty or sid/user_id equals "guest"
  useEffect(() => {
    let checkInterval = null;

    const checkCookies = () => {
      const isAuthenticated = localStorage.getItem("isAuthenticated");
      if (!isAuthenticated || forceLogoutRef.current) {
        return;
      }

      if (shouldAutoLogout()) {
        logoutCurrentSession();
      }
    };

    checkCookies();
    checkInterval = setInterval(checkCookies, 5000);

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkCookies();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      if (checkInterval) {
        clearInterval(checkInterval);
      }
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    const isAuthenticated = localStorage.getItem("isAuthenticated");
    if (isAuthenticated) {
      window.history.pushState(null, "", window.location.href);

      const handlePopState = () => {
        window.history.go(1); // Forces staying on the same page
      };

      window.addEventListener("popstate", handlePopState);

      return () => {
        window.removeEventListener("popstate", handlePopState);
      };
    }
  }, []);

  return (
    <div className="App">
      <SessionExpiredModal open={sessionExpired} onConfirm={forceLogoutNow} />
      <Router basename={basename}>
        <div className="portal-main-app">
          <ChunkErrorBoundary>
            <Suspense fallback={<PageLoader />}>
              <Routes>
              <Route
                path="/"
                element={
                  <PublicRoute>
                    <Commonlandingpage />
                  </PublicRoute>
                }
              />
              <Route
                path="/studentlandingpage"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <Studentlandingpage />
                  </Suspense>
                }
              />
              <Route
                path="/teacherlandingpage"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <TeacherLandingPage />
                  </Suspense>
                }
              />
              <Route
                path="/Organisationlandingpage"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <Organisation />
                  </Suspense>
                }
              />
              <Route
                path="/Contactus"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <ContactUsForm />
                  </Suspense>
                }
              />
              <Route
                path="/faqhelcenter"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <FAQSupportSection />
                  </Suspense>
                }
              />
              <Route
                path="/login"
                element={
                  <PublicRoute>
                    <Suspense fallback={<PageLoader />}>
                      <Login />
                    </Suspense>
                  </PublicRoute>
                }
              />
              <Route
                path="/guestlogin"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <GuestLoginPage />
                  </Suspense>
                }
              />
              <Route
                path="/guestloginpage"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <GuestLoginPage />
                  </Suspense>
                }
              />
              <Route
                path="/forgotpassword"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <ForgotPassword />
                  </Suspense>
                }
              />
              <Route
                path="/home"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <GuestHomePage />
                  </Suspense>
                }
              />
              <Route
                path="/viewallsolutions"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <Viewallsolutions />
                  </Suspense>
                }
              />
              <Route
                path="/instruction"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <Instruction />
                  </Suspense>
                }
              />
              <Route
                path="/studyadvisors"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <StudyAdvisors />
                  </Suspense>
                }
              />
              <Route
                path="/intructionpreview"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <InstructionPreview />
                  </Suspense>
                }
              />
              <Route
                path="/previewtestattempt"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <PreviewTestUI />
                  </Suspense>
                }
              />
              <Route
                path="/previewcongrats"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <PreviewCongratulations />
                  </Suspense>
                }
              />
              <Route
                path="/previewresultcard"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <PreviewResultCard />
                  </Suspense>
                }
              />
              <Route
                path="/previewreviewanswers"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <PreviewReviewAnswers />
                  </Suspense>
                }
              />
              <Route
                path="/previewstudyadvisor"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <PreviewStudyAdvisor />
                  </Suspense>
                }
              />
              <Route
                path="/previewrsolutionsheet"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <PreViewallsolutions />
                  </Suspense>
                }
              />
              <Route
                path="/AssessmentInstruction"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <AssessmentInstruction />
                  </Suspense>
                }
              />
              <Route
                path="/InstructionReg"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <InstructionReg />
                  </Suspense>
                }
              />
              <Route
                path="/getQuestionPaper"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <getQuestionPaper />
                  </Suspense>
                }
              />
              <Route
                path="/studentperformance"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentPerformanceLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/AdvancedSearchLOOQ"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AdvancedSearchLOOQLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/LOOQSearch"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <LOOQSearchLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/Createaccount"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <Createaccount />
                  </Suspense>
                }
              />
              <Route
                path="/faq"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <FaqPage />
                  </Suspense>
                }
              />
              <Route
                path="/congrats"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <Congratulations />
                  </Suspense>
                }
              />
              <Route
                path="/resultcard"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <ResultCard />
                  </Suspense>
                }
              />
              <Route
                path="/studyadvisor"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <StudyAdvisor />
                  </Suspense>
                }
              />
              <Route
                path="/results"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentResultsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/scheduleRevisionPlan"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <ScheduleRevisionPlan />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/AssessmentCloneDetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentCloneDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/userprofile"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <UserProfileLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/userprofileemail"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <UserProfileEmailLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/userprofileedit"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <UserProfileEditLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/userprofilepassword"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <UserProfilePasswordLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/userprofiledelete"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <UserProfileDeleteLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/advancedsearch"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AdvancedSearchPageLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/addtoanotherfolder"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AddtoanotherfolderLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/csvquestionupload"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <QuestionUploadCsvLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/surveyassessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <SurveyAssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/addtosurveyassessmentdetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AddtoSurveyAssessmentDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/assessmentcclonesurveydetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentClonesurveyDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/surveyassessmentdetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <SurveyAssessmentdetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/surveyassessmentseedetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentSurveySeeDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editsurveyassessmentdetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <EditSurveyAssessmentDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editassessmentdetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <EditAssessmentDetail />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/addtoassessmentdetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AddtoAssessmentDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editinstructionsdetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <EditInstructionDetail />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/questiondetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <QuestionDetailLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/teacherhomepage"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <TeacherLangingPageLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/studenthomepage"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentLandingScreenLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/getAiPropmpt"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <GetAiPropmpt />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/student-teacher-connect"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentTeacherConnect />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/student-teacher-connect-resource"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentTeacherConnectResource />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/search-teacher-connect"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentTeacherConnect />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/search-resource"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentTeacherConnect />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/student-self-study"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentSelfStudy />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/student-find-assessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentFindAssessment />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/student-see-results"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentSeeResults />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/questionadd"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <QuestionAddLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editquestion"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <EditQuestionLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/questionreview"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <QuestionReviewLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/createquestiondetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <CreateQuestionsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/createquestionadd"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <CreateAddQuestionsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/createeditquestion"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <CreateEditQuestionsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/createquestionreview"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <CreateQuestionsReviewLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editexistingquestion"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AllQuestionEditLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/existingquestiondetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AllQuestionDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/folder"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <FolderLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/aitutor/folder"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <FolderLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/genai"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <GenAILayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/ai-knowledge-base"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <GenAILayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/testattempt"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <TestUI />
                  </Suspense>
                }
              />
              <Route
                path="/reviewpage"
                element={
                  <Suspense fallback={<PageLoader />}>
                    <ReviewAnswers />
                  </Suspense>
                }
              />
              <Route
                path="/Selectedfolder"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentSelectedFolderLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/Assessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/selectedAssessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <SelectedAssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/AssessmentDetail"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/folderpage"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <SelectedFolderLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/folderpageassessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <FolderAssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/reviewAssessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <ReviewAssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/assessmentsettings"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentSettingsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/assessmentseedetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentSeeDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/seeresult"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <SeeResultLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/revieweditassessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <ReviewAssessmentEditDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editassessmentquestions"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AssessmentEditquestionsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editassessmentsetting"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <EditAssessmentSettingsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/editselectedfolder"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <EditSelectFolderAssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/resultdetails"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <ResultScreenDetailsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/resultsubmitted"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <ResultSubmittedLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/resultnotsubmitted"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <ResultNotSubmittedLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/allanswers"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AllAnswersLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/reviewdescriptive"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AnswerReviewDescriptiveLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/descriptivegrade"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <DescriptiveGradeLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/surveyresults"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <SurveyResults />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omruploadqns"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrUploadQuestionsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omransassign"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrAnswerAssignLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omrreviewassessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrReviewAssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omrassessmentsettings"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrAssessmentSettingsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omreditassessment"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrEditAssessmentLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omreditanswerassign"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrEditAnswerAssignLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omreditassessmentsettings"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrEditAssessmentsettingsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/omredituploadquestions"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <OmrEditUploadQuestionsLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/advancedSearchScreen"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <AdvancedSearchScreenLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
              <Route
                path="/ReusableDrawer"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <ReusableDrawerLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />
               <Route
                path="/studentviewallsolution"
                element={
                  <PrivateRoute>
                    <Suspense fallback={<PageLoader />}>
                      <StudentResultViewAllSolutionLayout />
                    </Suspense>
                  </PrivateRoute>
                }
              />

              </Routes>
            </Suspense>
          </ChunkErrorBoundary>
        </div>
      </Router>
    </div>
  );
}

export default App;
